import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { FC } from 'react'
import { CertificadoDigitalDto } from '../../../../../auth'
import { editCertificadoByUsuario } from '../../../../../auth/core/_requests'
import { Button, FetchState, LoadingIndicator, useModal } from '../../../../../../components'
import { useFormik } from 'formik'
import { certificadoSchema } from './validation/certificadoSchema'
import { useT } from '_metronic/i18n/Metronici18n'
import { UsuarioDtoVinculo } from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'

export const CertificadoUpload: FC = () => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()

  const { data: usuario } = (fetchStates['usuario'] || {}) as FetchState<UsuarioDtoVinculo>

  const fileToCertificadoDto = (
    file: File | undefined,
    action: 'u' | 'd'
  ): Promise<CertificadoDigitalDto> => {
    return new Promise((resolve, reject) => {
      if (!file && action === 'u') {
        reject(new Error('Arquivo é obrigatório para upload'))
        return
      }

      if (action === 'd') {
        resolve({ action: 'd' })
        return
      }

      const reader = new FileReader()
      reader.readAsDataURL(file as File)
      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1]
        resolve({
          action,
          fileContent: base64,
          fileName: file?.name,
          fileType: file?.type,
        })
      }
      reader.onerror = (error) => reject(error)
    })
  }

  const formik = useFormik({
    initialValues: {
      file: undefined,
    },
    validationSchema: certificadoSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (usuario) {
          const file = await fileToCertificadoDto(values.file, 'u')
          await editCertificadoByUsuario(usuario?.id, file)

          showAlert({
            title: 'Sucesso',
            text: 'Certificado cadastrado com sucesso!',
            icon: 'success',
          })
        }
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <span
        className={`${
          usuario?.pessoa?.certificadoDigital ? 'badge badge-success' : 'badge badge-danger'
        } mb-3 `}
      >
        {usuario?.pessoa?.certificadoDigital
          ? 'Profissional de saúde com certificado'
          : 'Médico sem certificado'}
      </span>

      <div className='fv-row mb-7'>
        <label className='required fw-bold me-3 mb-3 '>
          {usuario?.pessoa?.certificadoDigital ? 'Alterar arquivo' : 'Arquivo'}
        </label>
        <input
          name='file'
          type='file'
          onChange={(event) => {
            const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined
            formik.setFieldValue('file', file)
          }}
          className={`form-control ${
            formik.touched.file && formik.errors.file ? 'is-invalid' : ''
          }`}
        />
        {formik.touched.file && formik.errors.file && (
          <div className='invalid-feedback'>{formik.errors.file}</div>
        )}
      </div>

      <div className='d-flex justify-content-center'>
        <Button className='btn-secondary me-3' onClick={closeModal}>
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? (
            <LoadingIndicator />
          ) : usuario?.pessoa?.certificadoDigital ? (
            'Alterar certificado'
          ) : (
            t('common.save')
          )}
        </Button>
      </div>
    </form>
  )
}
